import { DOCUMENT } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.css']
})
export class FaqComponent {
  constructor(@Inject(DOCUMENT) private document: Document, private titleService: Title, private meta: Meta) {
    this.titleService.setTitle("Frequently Asked Questions | RankAhead");
    this.meta.addTag({
      name: 'description',
      content: 'Discover answers to frequently asked questions and learn how Rank Ahead works.'
    });
  }

  ngOnInit() {
    this.document.body.classList.add('toggle-sidebar');
  }
}
